module.exports = __webpack_public_path__ + "yz/img/安能.2a702d21.jpg";